export class BeanMonitoryCommentReply {
  recmNrSequencia: number | null;
  moniIdCdMonitoria : number | null;
  grcaIdCdGrupoCategoria : number | null;
  cateIdCdCategoria : number | null;
  pergIdCdPergunta : number | null;
  respIdCdResposta : number | null;
  recmTxComentario : string | null;
  usuaIdCdUsuario : number | null;
}
